


























































































import { Component, Vue } from "vue-property-decorator";
import ManageSpaceComponent from "@/app/components/manageSpace/manageSpace.component.vue";
import ProfileComponent from "@/app/components/profile/profile.component.vue";
import ConsoleMessageComponent from "@/app/components/modals/consoleMessage/consoleMessage.component.vue";
import BackgroundImageComponent from "@/app/components/modals/backgroundImage/backgroundImage.component.vue";
import ConfigDevicesComponent from "@/app/components/modals/configDevices/configDevices.component.vue";
import WebinarUrlComponent from "@/app/components/modals/webinarUrl/webinarUrl.component.vue";
import PaperPlaneMessageComponent from "@/app/components/modals/paperPlaneMessage/paperPlaneMessage.component.vue";
import UserInfoComponent from "@/app/components/modals/userInfo/userInfo.component.vue";
import WonderPointComponent from "@/app/components/modals/wonderPoint/wonderPoint.component.vue";
import OtherReasonComponent from "@/app/components/modals/otherReason/otherReason.component.vue";
import ChangeSpaceComponent from "@/app/components/modals/changeSpace/changeSpace.component.vue";
import HelpBotComponent from "@/app/components/modals/helpBot/helpBot.component.vue";
import WelcomeComponent from "@/app/components/onboarding/welcome.component.vue";
import MaintenaceComponent from "@/app/components/modals/maintenance/maintenance.component.vue";
import PhotonErrorComponent from "@/app/components/modals/photonError/photonError.component.vue";
import NetworkRequirementsComponent from "@/app/views/networkRequirements/networkRequirements.component.vue";
import ExitModalComponent from "@/app/components/modals/exitModal/exitModal.component.vue";
import TutorialModalComponent from "@/app/components/onboarding/tutorialModal/tutorialModal.component.vue";
import ProfileOnboardingComponent from "@/app/components/onboarding/profile/profileOnboarding.component.vue";
import ConfirmBanModal from "@/app/components/modals/banUser/confirmModal.component.vue";
import DescriptionBooth from "@/app/components/modals/descriptionBooth/descriptionBoothModal.component.vue";
import Vacation from "@/app/components/modals/vacationModal/vacationModal.component.vue";
import GoodMorningComponent from "@/app/components/modals/goodMorningModal/goodMorningModal.component.vue";
import WebGLContextLostModal from "@/app/components/modals/webGLContextLost/webGLContextLost.component.vue";
import CloseWebinarComponent from "@/app/components/modals/closeWebinar/closeWebinar.component.vue";
import CallErrorModalComponent from "@/app/components/modals/callError/callErrorModal.component.vue";
import SpeedNetworkingComponent from "@/app/components/modals/speedNetworking/speedNetworking.component.vue";
import SpeedNetworkingEnterComponent from "@/app/components/modals/speedNetworkingEnter/speedNetworking.component.vue";
import ConsoleMessageMultiSpaceComponent from "@/app/components/modals/consoleMessage/consoleMessageMultiSpace.component.vue";
import PinModalComponent from "@/app/components/modals/pinModal/pinModal.component.vue";
import RoomPinModalComponent from "@/app/components/modals/roomPinModal/roomPinModal.component.vue";
import MeetingUrlComponent from "@/app/components/modals/meetingUrl/meetingUrl.component.vue";
import EventCalendarComponent from "@/app/components/modals/eventCalendar/eventCalendar.component.vue";
import PosterModalComponent from "@/app/components/modals/posterModal/posterModal.component.vue";
import WebinarEnterComponent from "@/app/components/modals/webinarEnter/webinar.component.vue";
import CallModalComponent from "@/app/components/modals/callModal/call.component.vue";
import ErrorGeneralClientGraphicComponent from "@/app/components/modals/errorGeneralClientGraphic/errorGeneralClientGraphic.vue";
import CallRetryErrorModalComponent from "@/app/components/modals/callError/callRetryErrorModal.component.vue";
import BirthdayModalComponent from "@/app/components/modals/birthday/birthdayModal.component.vue";
import NotepadModalComponent from "@/app/components/modals/notepadModal/notepadModal.component.vue";
import ProfileOnboardingTeamsComponent from "@/app/components/onboarding/profile/profileOnboardingTeams.component.vue";
import RobotModalComponent from "@/app/components/modals/robot/robotModal.component.vue";
import EducationModalComponent from "@/app/components/modals/education/educationModal.component.vue";
import EducationToolModalComponent from "@/app/components/modals/education/educationToolModal.component.vue";
import SpotifyModalComponent from "@/app/components/modals/CTTI/spotifyModal.component.vue";
import GameKillerModalComponent from "@/app/components/modals/gameKiller/gameKillerModal.component.vue";
import GameKillerModalInfoComponent from "@/app/components/modals/gameKiller/gameKillerInfoModal.component.vue";
import GameKillerModalVoteAndWinnerComponent from "@/app/components/modals/gameKiller/gameKillerVoteAndWinnerModal.component.vue";
import ReserveRoomModal from "@/app/components/modals/reserveRoom/reserveRoomModal.component.vue";
import CttiGameModalComponent from "@/app/components/modals/CTTI/cttiGameModal.component.vue";
import AutoVideoEnterModalComponent from "@/app/components/modals/CTTI/autoVideoEnterModal.component.vue";
import AutoVideoComponent from "@/app/components/modals/CTTI/autoVideo.component.vue";
import ReservePhysicalRoomModal from "@/app/components/modals/reserveRoom/reservePhysicalRoomModal.component.vue";
import PlanWarningPremium from "@/app/components/modals/plan/planWarningPremium.component.vue";

@Component({
  name: "modals-view",
  components: {
    SpeedNetworkingEnterComponent,
    SpeedNetworkingComponent,
    CallErrorModalComponent,
    CloseWebinarComponent,
    GoodMorningComponent,
    ProfileOnboardingComponent,
    ExitModalComponent,
    WelcomeComponent,
    ChangeSpaceComponent,
    OtherReasonComponent,
    WonderPointComponent,
    UserInfoComponent,
    PaperPlaneMessageComponent,
    WebinarUrlComponent,
    BackgroundImageComponent,
    ConfigDevicesComponent,
    ConsoleMessageComponent,
    ProfileComponent,
    ManageSpaceComponent,
    HelpBotComponent,
    PhotonErrorComponent,
    NetworkRequirementsComponent,
    MaintenaceComponent,
    TutorialModalComponent,
    ConfirmBanModal,
    DescriptionBooth,
    Vacation,
    WebGLContextLostModal,
    ConsoleMessageMultiSpaceComponent,
    PinModalComponent,
    RoomPinModalComponent,
    MeetingUrlComponent,
    EventCalendarComponent,
    PosterModalComponent,
    WebinarEnterComponent,
    CallModalComponent,
    ErrorGeneralClientGraphicComponent,
    CallRetryErrorModalComponent,
    BirthdayModalComponent,
    NotepadModalComponent,
    ProfileOnboardingTeamsComponent,
    RobotModalComponent,
    EducationModalComponent,
    EducationToolModalComponent,
    SpotifyModalComponent,
    GameKillerModalComponent,
    GameKillerModalInfoComponent,
    GameKillerModalVoteAndWinnerComponent,
    ReserveRoomModal,
    CttiGameModalComponent,
    AutoVideoEnterModalComponent,
    AutoVideoComponent,
    ReservePhysicalRoomModal,
    PlanWarningPremium,
  },
})
export default class Modals extends Vue {
  get active(): boolean {
    return this.$store.getters["MeetingStore/getOpenDevicesConfig"];
  }
  set active(e: boolean) {
    this.$store.dispatch("MeetingStore/setOpenDevicesConfigAction", e);
  }
  get activeBackgroundImages(): boolean {
    return this.$store.getters["MeetingStore/getOpenBackgroundImages"];
  }
  set activeBackgroundImages(e: boolean) {
    this.$store.dispatch("MeetingStore/setOpenBackgroundImagesAction", e);
  }
  get activeConsoleMessage(): boolean {
    return this.$store.getters["FloatMenuStore/getOpenConsoleMessage"];
  }
  get activeConsoleMessageMuliSpace(): boolean {
    return this.$store.getters[
      "FloatMenuStore/getOpenConsoleMessageMultiSpace"
    ];
  }
  get activeOpenProfile(): boolean {
    return (
      this.$store.getters["FloatMenuStore/getOpenProfile"] &&
      !this.$store.getters["SystemStore/getShowCompleteOnBoarding"] && 
      !this.$store.getters["SystemStore/getShowCompleteOnBoardingTeams"]
    );
  }
  get activeOpenOnBoardingProfileTeams(): boolean {
    return (
      this.$store.getters["FloatMenuStore/getOpenProfile"] &&
      this.$store.getters["SystemStore/getShowCompleteOnBoardingTeams"]
    );
  }
  get activeOpenOnBoardingProfile(): boolean {
    return (
      this.$store.getters["FloatMenuStore/getOpenProfile"] &&
      this.$store.getters["SystemStore/getShowCompleteOnBoarding"]
    );
  }
  get activePaperPlaneModal(): boolean {
    return this.$store.getters["SystemStore/getOpenPaperPlaneModal"];
  }
  get activeOpenInfoModal(): boolean {
    return this.$store.getters["SystemStore/getOpenUserInfoModal"];
  }
  get activeOpenWonderPointModal(): boolean {
    return this.$store.getters["SystemStore/getOpenWonderPointModal"];
  }
  get activeChangeAvatarModal(): boolean {
    return this.$store.getters["FloatMenuStore/getOpenAvatarSelector"];
  }
  get activeHelpBotModal(): boolean {
    return this.$store.getters["FloatMenuStore/getOpenHelpBot"];
  }
  get activeManageSpace(): boolean {
    return this.$store.getters["FloatMenuStore/getManageSpace"];
  }
  get activeChangeSpace(): boolean {
    return this.$store.getters["SystemStore/getOpenChangeSpaceModal"];
  }
  get activeMaintenanceModal(): boolean {
    return this.$store.getters["SystemStore/getMaintenanceModal"];
  }
  get activePhotonErrorModal(): boolean {
    return this.$store.getters["SystemStore/getShowPhotonErrorModal"];
  }
  get activeNetworkRequirements(): boolean {
    return this.$store.getters["SystemStore/getShowNetworkRequirements"];
  }
  get exitNubii(): boolean {
    return this.$store.getters["SystemStore/getExitModal"];
  }
  get activateTutorial(): boolean {
    return this.$store.getters["SystemStore/getTutorialModal"];
  }
  get activateConfirmBan(): boolean {
    return this.$store.getters["SystemStore/getConfirmBanModal"];
  }
  get activateDescriptionBooth(): boolean {
    return this.$store.getters["SystemStore/getDescriptionBoothModal"];
  }
  get activateVacationModal(): boolean {
    return this.$store.getters["SystemStore/getVacationModal"];
  }
  get showGoodMorningModal(): boolean {
    return this.$store.getters["SystemStore/getShowGoodMorningModal"];
  }
  get showWebGLContextLostModal(): boolean {
    return this.$store.getters["SystemStore/getShowWebGLContextLostModal"];
  }
  get showCallErrorModal(): boolean {
    return this.$store.getters["SystemStore/getShowCallErrorModal"];
  }
  get showWebinarModal(): boolean {
    return this.$store.getters["MeetingStore/getOpenWebinarUrl"].active;
  }
  get showPinModal(): boolean {
    return this.$store.getters["SystemStore/getShowPinModal"];
  }
  get showPinRoomModal(): boolean {
    return this.$store.getters["SystemStore/getShowPinRoomModal"];
  }
  get showMeetingModal(): boolean {
    return this.$store.getters["MeetingStore/getOpenMeetingUrl"];
  }
  get showCalendarModal(): boolean {
    return this.$store.getters["FloatMenuStore/getOpenCalendarModal"];
  }
  get openPosterModal() {
    return this.$store.getters["SystemStore/getOpenPosterModal"];
  }
  get openCallModal() {
    return this.$store.getters["MeetingStore/getShowCallModal"];
  }
  get openErrorGeneralClientGraphicModal() {
    return this.$store.getters["SystemStore/getErrorGeneralClientGraphic"];
  }
  get openCallRetryErrorModal() {
    return this.$store.getters["SystemStore/getShowCallErrorRetryModal"];
  }
  get openBirthdayModal() {
    return this.$store.getters["SystemStore/getShowBirthdayModal"];
  }
  get openNotepadModal() {
    return this.$store.getters["SystemStore/getOpenNotepadModal"];
  }
  get openCttiGameModal(): boolean {
    return this.$store.getters["SystemStore/getCttiGameModal"];
  }
}
